const mutations = {

}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/contcat/mutations/index.js